module.exports = __webpack_public_path__ + "img/home_bg.accfdfd7.jpg";